// styles
import {
    InventoryItemPanelContainer,
    ItemTitle,
    StatRow,
    Stat,
    StatLabel,
    StatValue,
    RightContainer
} from './InventoryItemPanel.styles.js';

// components
import PrimaryBtn from '../../../../../../components/btns/primary-btn/PrimaryBtn.js';
import SecondaryBtn from '../../../../../../components/btns/secondary-btn/SecondaryBtn.js';

export default function InventoryItemPanel({ item, onEdit }) {
    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return '$0.00';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount);
    };

    const itemName = item?.itemName || 'Untitled item';
    const quantity = Number.isFinite(item?.quantity) ? item.quantity : 0;
    const totalCostValue = Number.isFinite(item?.totalCost) ? item.totalCost : parseFloat(item?.totalCost) || 0;
    const totalCost = formatCurrency(totalCostValue);
    const url = item?.url?.trim();

    return (
        <InventoryItemPanelContainer className='panel-bg'>
            <ItemTitle>{itemName}</ItemTitle>


            <RightContainer>
                <StatRow>
                    <Stat>
                        <StatLabel>Quantity</StatLabel>
                        <StatValue>{quantity}</StatValue>
                    </Stat>
                    <Stat>
                        <StatLabel>Total Cost</StatLabel>
                        <StatValue>{totalCost}</StatValue>
                    </Stat>
                    <Stat>
                        <StatLabel>Unit Cost</StatLabel>
                        <StatValue>
                            {quantity > 0 ? formatCurrency(totalCostValue / quantity) : '$0.00'}
                        </StatValue>
                    </Stat>
                </StatRow>
                <SecondaryBtn title="EDIT" onClick={onEdit} />
                {url && (
                    <PrimaryBtn
                        title="RE-ORDER"
                        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                    />
                )}
            </RightContainer>
        </InventoryItemPanelContainer>
    )
}
